import React from "react";
import Select, { OnChangeValue } from "react-select";
import * as Commons from "oc-commons/Commons";

const create = "✴";

export const NodeRefInput = ({ node, property, setSelected, nodeIndex, isTopNode }) => {
  const value = property.get() ?? property.createDefault() ?? "";
  const options = property
    .getSelectOptions()
    .map((o) => ({ value: o, label: o }))
    .concat([{ value: create, label: "create new..." }]);
  const createNew = () => {
    const nodeList = property.getNodeList();
    const instance = nodeList.createNode();
    nodeList.add(instance);
    property.set(null);
    setSelected(instance, nodeList);
  };
  const onChange = (newValue: OnChangeValue<any, any>, actionMeta) => {
    const v = newValue?.value;
    if (v == create) {
      createNew();
      return;
    }
    const v1 = Commons.isEmpty(v) ? null : v;
    property.set(v1);
    APP.sceneNode.callDebouncedUpdateSceneOn(property.node);
  };
  const optionValue = options.find((o) => o.value == value) ?? "";

  return (
    <div className="flex-row">
      <Select
        className="comboSelectInput"
        classNamePrefix="comboSelectInput"
        isClearable={true}
        value={optionValue}
        onChange={onChange}
        options={options}
      />
      <span>&nbsp;</span>
      {value != "" ? (
        <div
          className="button"
          title="edit"
          onClick={() => setSelected(property.getNode(), property.getNodeList())}
        >
          ✎
        </div>
      ) : (
        <div className="button" title="create new" onClick={createNew}>
          ✴
        </div>
      )}
    </div>
  );
};
